<template>
  <div class="left-tree">
    <div class="left-tree-title"><span></span><slot></slot></div>
    <el-tree
      ref="tree"
      :data="topicCategorys"
      :props="defaultProps"
      node-key="value"
      :default-expanded-keys="defaultExpandedKeys"
      :current-node-key="this.$route.query.CategoryB || this.$route.query.CategoryA"
      accordion
      @node-click="handleNodeClick"
      @node-expand="handleExpandClick"
      >
    </el-tree>
  </div>
</template>

<script>
export default {
  name: 'TreeList',
  data () {
    return {
      defaultProps: {
        children: 'subdata',
        label: 'value'
      },
      defaultExpandedKeys: [],
      expandNodeName: ''
    }
  },
  props: {
    topicCategorys: Array
  },
  watch: {
    $route: {
      handler: function (val) {
        this._initCheck()
        if (!this.$route.query.CategoryB) {
          this.$refs.tree.setCurrentKey(this.$route.query.CategoryA)
        }
      },
      deep: true
    }
  },
  computed: {
  },
  methods: {
    handleExpandClick (data) {
      this.expandNodeName = data.value
      this.defaultExpandedKeys = [data.value]
    },
    async handleNodeClick(data) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.defaultExpandedKeys = []
        let currentId = data.$treeNodeId
        let totalIndex = currentId
        let name = this.$route.name
        if (!this.totalIndex) {
          this.totalIndex = this.$route.query.totalIndex
        }
        if (data.subdata.length > 0) {
          totalIndex += data.subdata.length
          this.totalIndex = totalIndex
          this.$router.replace({ path: name, query: { CategoryA: data.value, CategoryB: '', totalIndex: this.totalIndex } })
        } else {
          let CategoryA = this.expandNodeName || this.$route.query.CategoryA
          this.$router.replace({ path: 'entry', query: { CategoryA: CategoryA, CategoryB: data.value, totalIndex: this.totalIndex } })
        }
      }
    },
    _initCheck () {
      const CategoryA = this.$route.query.CategoryA
      if (CategoryA !== undefined) {
        this.defaultExpandedKeys = [CategoryA]
      }
    }
  },
  mounted () {
    this._initCheck()
  }
}
</script>

<style lang="less" scoped>
.left-tree {
  float: left;
  width: 240px;
  min-height: 800px;
  background: #f4f4f4;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  /deep/.is-checked {
    .el-tree-node__content {
      .el-tree-node__label {
        color: #1743A5;
        text-decoration-line: underline;
      }
    }
    .el-tree-node__children {
      .el-tree-node__label {
        color: #606266;
        text-decoration-line: none;
      }
    }
  }
  /deep/.is-current {
      .el-tree-node__content {
        .expanded  {
          &.el-icon-caret-right {
            &::before {
              content: "\e6d8";
            }
          }
        }
        .el-icon-caret-right {
          &::before {
            content: "\e6d9";
          }
        }
        .el-tree-node__label {
          color: #1743A5;
          text-decoration-line: underline;
        }
      }
      .el-tree-node__children {
        .el-tree-node {
          .el-tree-node__expand-icon {
            &.is-leaf {
              &::before {
                content: '·';
                color: #ffffff;
              }
            }
          }
        }
        .el-tree-node__label {
          color: #606266;
          text-decoration-line: none;
        }
      }
    }
  /deep/.el-tree-node__content {
    width:220px;
    height:32px;
    &:hover {
      background-color: transparent;
      color: #1743a5;
    }
    .expanded  {
      transform: rotate(0deg);
      &.el-icon-caret-right {
        &::before {
          border: 1px solid #bbbbbb;
          content: "\e6d8";
        }
      }
    }
    .el-icon-caret-right {
      &::before {
        border: 1px solid #bbbbbb;
        content: "\e6d9";
      }
    }
  }
  /deep/.el-tree-node__children {
    .el-tree-node {
      .el-tree-node__expand-icon {
        &.is-leaf {
          &::before {
            content: '·';
            border: none;
            color: #ffffff;
          }
        }
      }
    }
  }
  /deep/.el-tree-node__children {
    .el-tree-node {
      .el-tree-node__content {
        .el-tree-node__expand-icon {
          &.is-leaf {
            &::before {
              content: '·';
              color: #999999;
            }
          }
        }
      }
    }
    .is-current {
      .el-tree-node__content {
        background-color: #4160A5;
        .el-tree-node__label {
          color: #FFFFFF;
          background-color: #4160A5;
          text-decoration-line: none;
        }
      }
    }
  }
  .left-tree-title {
    height: 50px;
    border-bottom: 1px solid #DDDDDD;
    line-height: 50px;
    font-size: 16px;
    color: #333333;
    position: relative;
    width: 210px;
    margin: 0 auto;
    text-indent: 30px;
    span {
      &::before {
        content: "";
        position: absolute;
        height: 14px;
        width: 14px;
        background: url("../../assets/imgs/title-bg-top.png") no-repeat;
        left: 0;
        top: 18px;
      }
      &::after {
        content: "";
        position: absolute;
        height: 14px;
        width: 14px;
        background: url("../../assets/imgs/title-bg-top.png") no-repeat;
        top: 23px;
        left: 6px;
      }
    }
  }
  .el-tree {
    background:#f4f4f4;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/treeList/TreeList.vue